import styled from "@emotion/styled/macro";

const AddInnerModalWrapper = styled.div`
  > p {
    font-size: 14px !important;
  }

  h2 {
    font-size: 18px !important;
    margin: 10px 0 0 0;
    padding-bottom: 8px;
  }
`;

export default AddInnerModalWrapper;